import Cookies from 'js-cookie';
import axios from 'axios';
import { getHeaders } from '@/api/requestHeaders';
import { environment } from '@/env/env.prod';
import { refreshInstituteType } from '@/lib/instituteLabels';

async function requestSignin({
  authToken,
  id,
  ins_code,
  user_id
}) {
  try {
    const designation = 1;
    const dashboard_login = 1;
    const device_token = "null device token !"
    const body = {
      id,
      parent: ins_code,
      designation,
      dashboard_login,
      device_token,
      parent: ins_code,
    };

    //console.log(`SENDING PARAMETERS ! ${JSON.stringify(params)}`);

    const response = await axios.post(
      `${environment.BASE_URL}/web/login`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`,  // ✅ from param, not cookie
          "X-INSTITUTE": ins_code,                 // ✅ from param
          "X-E-ID": id,                            // ✅ from param
          "X-FACULTY": "1",
        },
      }
    );
    console.log('Response:', response);
    const fs_data = response.data[ 'firestoreUserData' ]
    Cookies.set('E_id', fs_data[ 'E_id' ])
    Cookies.set('img', fs_data[ 'img' ])
    Cookies.set('name', fs_data[ 'name' ])
    Cookies.set('authToken', authToken)
    Cookies.set('ins_code', ins_code)
    Cookies.set('user_uid', user_id)
    // check if role otherwise set faculty if Fac === 1
    // 🔹 Extract or infer role
    let role = 'faculty'; // default fallback
    if (fs_data.role) {
      role = fs_data.role.toLowerCase();
    } else if (typeof fs_data.Fac !== 'undefined') {
      role = fs_data.Fac === 1 ? 'faculty' : 'student';
    }
    Cookies.set('role', role);
    // Institute type (UI wording) — needs the session cookies set above
    await refreshInstituteType();

    if (fs_data.Fac !== 1) {
      return false
    }

    // time of login also add in cookies 
    if (response.status === 200) {
      return true;
    }
    return true;

  } catch (error) {
    if (error.code == 200) {

    }
    console.error('Error in signin request:', error.message);
    return false;
  }
}


async function request_entities({
  page_size = 5,
  last_pagination_value = undefined,
  entity_search = undefined,
  query_entity_type = 'teachers' // teachers , students , admins , librarians 
} = {}) {
  try {
    const authToken = Cookies.get('authToken');
    const ins_code = Cookies.get('ins_code');
    const E_id = Cookies.get('E_id');
    //console.log("LOG VALS !", ins_code, E_id);
    const params = {
      authToken,
      ins_code,
      E_id,
      page_size,
      last_pagination_value,
      entity_search,
      query_entity_type,
    };
    //console.log(`SENDING PARAMETERS ! ${JSON.stringify(params)}`);
    const response = await axios.get(
      `${environment.BASE_URL}/fetch_database_entities`,
      { params }
    );
    //console.log('Response:', response);
    if (response.status === 200) {
      return response; // return the real response
    }
    return false;
  } catch (error) {
    console.error('Error in request_entities:', error.message);
    return false;
  }
}





export {
  requestSignin,
  request_entities
}